<div class="container">
  <div class="spinner">
    <img [src]="'HOME.HEADER.IMAGE' | translate" />
    <h4 class="title-large bold" [innerHTML]="combinedHeaderText"></h4>
    <p class="title-medium semi-bold">
      {{ currentMessage | translate }}
    </p>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
